import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CalendarDays, Target, LogOut, UserRound } from "lucide-react";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";
import { useAuth } from "@/components/auth/AuthProvider";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

export const HeaderMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();
  const { user, signOut } = useAuth();

  if (!user) return null;

  // Calculate the increased avatar size (15% larger)
  const mobileAvatarSize = "h-9 w-9"; // Up from h-8 w-8
  const desktopAvatarSize = "h-10.5 w-10.5"; // Up from h-9 w-9

  return <div className="w-full bg-background shadow-sm border-b">
      <div className="container mx-auto px-4 py-3">
        <div className={`flex ${isMobile ? "flex-col items-start space-y-3" : "items-center justify-between"}`}>
          <div className="flex items-center">
            <img src="/lovable-uploads/30008be8-fb34-4cd0-9274-69d659959b43.png" alt="Habilou Logo" className="h-[46px] md:h-[55.2px]" />
            
            <div className={`flex ${isMobile ? "w-full justify-start space-x-2 mt-3" : "ml-[50px] space-x-3"}`}>
              <Button variant={location.pathname === "/" ? "default" : "ghost"} onClick={() => navigate("/")} className={cn("flex items-center gap-1 font-parkinsans", location.pathname === "/" && "text-white", isMobile && "text-xs px-2 py-1 h-8")}>
                <Target size={isMobile ? 14 : 18} />
                {isMobile ? "Habits" : "Habit Tracker"}
              </Button>
              
              <Button variant={location.pathname === "/planner" ? "default" : "ghost"} onClick={() => navigate("/planner")} className={cn("flex items-center gap-1 font-parkinsans", location.pathname === "/planner" && "text-white", isMobile && "text-xs px-2 py-1 h-8")}>
                <CalendarDays size={isMobile ? 14 : 18} />
                {isMobile ? "Planner" : "Daily Planner"}
              </Button>
            </div>
          </div>
          
          <div className={`${isMobile ? "self-end" : ""}`}>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon" className="rounded-full p-0">
                  <Avatar className={isMobile ? mobileAvatarSize : desktopAvatarSize}>
                    <AvatarFallback>
                      <UserRound className={isMobile ? "h-5 w-5" : "h-6 w-6"} />
                    </AvatarFallback>
                  </Avatar>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem 
                  onClick={() => {
                    signOut();
                    navigate('/login');
                  }} 
                  className="group flex items-center gap-2 hover:bg-[#9b87f5] hover:text-white cursor-pointer transition-colors duration-200"
                >
                  <LogOut className="h-4 w-4 group-hover:text-white" />
                  Logout
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      </div>
    </div>;
};
